import { fetchJson } from './apiClient';

export async function getSubscriptionSummary() {
  return fetchJson('/api/admin/subscriptions/summary');
}

export async function listExpiredSubscriptions() {
  return fetchJson('/api/admin/subscriptions/expired');
}

export async function notifyExpiredUsers(ids: string[]) {
  // Use centralized client so Authorization header is injected
  return fetchJson('/api/admin/subscriptions/notify-expired', {
    method: 'POST',
    body: JSON.stringify({ ids }),
  });
}

export async function listSubscriptionPlans() {
  // Returns array of subscription plan objects from admin endpoint
  return fetchJson('/api/admin/subscription-plans');
}
